export default {
    setConnectedAccounts(state, payload) {
        state.connectedAppStoreAccounts = payload;
    },
    setClientDetails(state, payload) {
        state.authUrl = payload;
    },
    setPackages(state,payload){
        state.packages = payload;
    }
}
